var eq = function eq(x) {
  return function (y) {
    return x === y;
  };
};
export default eq;